import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isFixed, setIsFixed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('section');
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        setIsFixed(window.scrollY > heroBottom);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <nav
        className={`${isFixed ? 'fixed' : 'absolute'} top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isFixed ? 'bg-white shadow-lg py-3 md:py-4' : 'bg-transparent py-4 md:py-6'
        }`}
      >
        <div className={`${isFixed ? 'max-w-7xl' : 'max-w-full'} mx-auto px-6 md:px-8 flex items-center justify-between`}>
          <div
            className={`font-light tracking-[0.2em] text-xs md:text-sm transition-colors duration-300 ${
              isFixed ? 'text-gray-900' : 'text-white'
            }`}
          >
             
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              isFixed ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          <ul className="hidden md:flex items-center gap-6 lg:gap-8">
            {[
              { label: 'Portfolio', id: 'work' },
              { label: 'About Me', id: 'about' },
              { label: 'Resume', id: 'resume' }
            ].map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  className={`text-sm font-medium tracking-wide hover:text-[#FF6B4A] transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                    isFixed ? 'text-gray-900' : 'text-white'
                  }`}
                >
                  {item.label}
                </button>
              </li>
            ))}
            <li>
              <a
                href="mailto:ookpareke@gmail.com"
                className="px-6 py-2.5 bg-[#FF6B4A] text-white text-sm font-medium tracking-wide rounded-full hover:bg-[#FF5A3A] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Let's Connect
              </a>
            </li>
            <li>
              <a 
                href="https://www.linkedin.com/in/okennaokpareke/" 
                target="_blank" 
                rel="noopener noreferrer"
                className={`w-10 h-10 rounded-full flex items-center justify-center border transition-all duration-300 cursor-pointer ${
                  isFixed 
                    ? 'bg-gray-100 border-gray-200 hover:bg-gray-200 text-gray-900' 
                    : 'bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 text-white'
                }`}
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </li>
            <li>
              <a 
                href="mailto:ookpareke@gmail.com"
                className={`w-10 h-10 rounded-full flex items-center justify-center border transition-all duration-300 cursor-pointer ${
                  isFixed 
                    ? 'bg-gray-100 border-gray-200 hover:bg-gray-200 text-gray-900' 
                    : 'bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 text-white'
                }`}
              >
                <i className="ri-mail-fill text-lg"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white md:hidden">
          <div className="flex flex-col items-center justify-center h-full gap-8 px-6">
            {[
              { label: 'Portfolio', id: 'work' },
              { label: 'About Me', id: 'about' },
              { label: 'Resume', id: 'resume' }
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-2xl font-medium text-gray-900 hover:text-[#FF6B4A] transition-colors duration-300 cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <a
              href="mailto:ookpareke@gmail.com"
              className="px-8 py-3 bg-[#FF6B4A] text-white text-xl font-medium rounded-full hover:bg-[#FF5A3A] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Let's Connect
            </a>
            <div className="flex items-center gap-4 mt-4">
              <a 
                href="https://www.linkedin.com/in/okennaokpareke/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center hover:bg-gray-200 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-gray-900 text-xl"></i>
              </a>
              <a 
                href="mailto:ookpareke@gmail.com"
                className="w-12 h-12 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center hover:bg-gray-200 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-mail-fill text-gray-900 text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
